import { h, Fragment } from 'preact';
import { useState, useRef, useEffect } from 'preact/hooks';
import Panel from 'utils/panel';
import { formatMoney } from 'utils/format-money';
import Icon from 'utils/icon';
import CartItem from './cart-item';
import { withCartContext } from './cart-context';

const Cart = (props) => {
  const { cart } = props;
  const closeTriggerEl = useRef(null);
  const isCartRedirect = new URLSearchParams(location.search).get('cart');
  const [panelTriggers, setPanelTriggers] = useState({
    openTriggerEl: 'data-header-cart-trigger',
    closeTriggerEl: 'data-mini-cart-close',
  });

  useEffect(() => {
    if (!closeTriggerEl.current) return;
    setPanelTriggers((value) => ({
      ...value,
      closeTriggerEl: 'data-mini-cart-close',
    }));
  }, [closeTriggerEl]);

  const totalQuantity = () => {
    const lineItemsQuantity = cart?.state?.item_count ? `(${cart?.state?.item_count})` : '(0)';
    return lineItemsQuantity;
  };

  useEffect(() => {
    document.querySelector('[data-header-cart-quantity]').innerText = totalQuantity();
  }, [cart]);

  const scrapeData = () => {
    const dataEl = document.querySelector('#cart');
    if (!dataEl) return {};

    try {
      return JSON.parse(dataEl.textContent);
    } catch {
      console.warn('Error parsing data');
      return {};
    }
  };
  const scrapedData = scrapeData();

  const promoBanner = document.querySelector('.promo-bar');
  const miniCartOverlap = promoBanner ? true : null;

  return (
    <Panel triggers={panelTriggers} defaultOpen={isCartRedirect} context="cart">
      <div
        className={`relative ${
          miniCartOverlap
            ? 'h-[calc(100%-35px)] h-[calc(100dvh-35px)] lg:h-[100%]'
            : 'h-[100%] h-[100dvh]'
        }`}
      >
        <div className="py-[31px] pl-[20px] border-b-1 border-grey-400 flex items-center gap-3">
          <p className="text-s9 uppercase">{TMW.Strings.cart.title}</p>
          {cart?.state?.lines?.length > 0 ? (
            <span className="text-s9">{totalQuantity()}</span>
          ) : null}
          <button
            type="button"
            ref={closeTriggerEl}
            data-mini-cart-close
            className="absolute top-[15px] -left-[55px] mini-cart__close hidden"
          >
            <Icon id="close" className={'pointer-events-none text-white'} />
          </button>
        </div>
        <div className="cart-items h-[calc(100%-15px)] overflow-y-scroll scrollbar-hide">
          {cart?.state?.lines?.length > 0 ? (
            <Fragment>
              {cart?.state?.lines?.map((line) => (
                <CartItem key={line.id} line={line} />
              ))}
            </Fragment>
          ) : (
            <div className="cart-empty pt-[35px] pl-[20px]">
              <p className="cart-empty__heading text-s2 mb-[36px]">
                {' '}
                {scrapedData.title}
              </p>
              {scrapedData.first_cta_url && scrapedData.first_cta ? (
                <a
                  className="inline-block cart-empty__first-cta text-h6 mr-[10px] py-[15px] whitespace-nowrap mb-[10px] px-[11px] border-1 border-black cursor-pointer rounded-[6px] text-text-1"
                  href={scrapedData.first_cta_url}
                >
                  {scrapedData.first_cta}
                </a>
              ) : null}
              {scrapedData.second_cta_url && scrapedData.second_cta ? (
                <a
                  className="inline-block cart-empty__second-cta text-h6 mb-[10px] py-[15px] px-[11px] whitespace-nowrap border-1 border-black cursor-pointer rounded-[6px] text-text-1"
                  href={scrapedData.second_cta_url}
                >
                  {scrapedData.second_cta}
                </a>
              ) : null}
            </div>
          )}
        </div>
        {cart.state.lines?.length > 0 ? (
          <div className="fixed bottom-0 pb-[20px] bg-white border-t-1 border-grey-400 w-full">
            <div className="subtotal flex space-between px-[20px] py-[20px]">
              <span className="w-[50%] text-h6 uppercase">
                {TMW.Strings.cart.subtotal}
              </span>
              <span className="w-[50%] text-s2 text-right font-medium">
                {formatMoney({ amount: cart.state?.subtotal }, true)}
              </span>
            </div>
            <a
              className="justify-center w-[calc(100%-40px)] button button--tertiary text-s2 rounded-[0px] h-[50px] mx-[20px]"
              href={`/cart/c/${cart.state.token}`}
            >
              {TMW.Strings.cart.checkout}
            </a>
          </div>
        ) : null}
      </div>
    </Panel>
  );
};

export default withCartContext(Cart);